import { createAuthClient } from 'better-auth/react'
import { magicLinkClient, customSessionClient, inferAdditionalFields } from 'better-auth/client/plugins'
import type { auth } from './auth'

export const { signIn, signUp, signOut, useSession } = createAuthClient({
    plugins: [magicLinkClient(), customSessionClient<typeof auth>(), inferAdditionalFields<typeof auth>()]
})
